<div class="report-container">
    <div class="summary-cards">
        <div class="card green">
            <h2>{{ totalRecords }}</h2>
            <p>Total Records</p>
        </div>
        <div class="card green">
            <h2>{{ successCount }}</h2>
            <p>Successful</p>
        </div>
        <div class="card orange">
            <h2>{{ skippedCount }}</h2>
            <p>Skipped</p>
        </div>
        <div class="card red">
            <h2>{{ failedCount }}</h2>
            <p>Failed</p>
        </div>
    </div>
    <div class="history-card">
        <table class="history-table">
            <thead>
                <tr>
                    <th (click)="sortuser('status')">Status</th>
                    <th (click)="sortuser('msisdn')">MSISDN</th>
                    <th (click)="sortuser('songName')">Song</th>
                    <th (click)="sortuser('plan')">Plan</th>
                    <th (click)="sortuser('currency')">Currency</th>
                    <th (click)="sortuser('message')">Message</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngIf="paginateduser.length === 0">
                    <td colspan="6" class="no-record">No matching records found</td>
                </tr>
                <tr *ngFor="let row of paginateduser">
                    <td>
                        <span class="common_message" [ngClass]="{
          'status-success': row.status === 'SUCCESS',
          'status-failed': row.status === 'FAIL',
          'status-skipped': row.status === 'SKIPPED'
        }">

                            <i class="fa" [ngClass]="{
         'fa-check-circle': row.status === 'SUCCESS',
         'fa-times-circle': row.status === 'FAIL',
         'fa-info-circle': row.status === 'SKIPPED'
       }">
                            </i>

                            {{ row.status }}
                        </span>
                    </td>
                    <td>{{ row.msisdn }}</td>
                    <td>{{ row.songName }}</td>
                    <td>{{ row.plan }}</td>
                    <td>{{ row.currency }}</td>
                    <td>{{ row.message }}</td>
                </tr>
            </tbody>
        </table>

        <nav *ngIf="filtereduser.length > rowsPerPage2" class="pagination-controls">
            <span class="entries">
                Showing {{ getStartIndex() }} to {{ getEndIndex() }} of {{ filtereduser.length }} entries
            </span>
            <div class="pagination-buttons">
                <button class="page-btn" [disabled]="currentPage2 === 1"
                    (click)="changePage2(currentPage2 - 1)">Previous</button>
                <ng-container *ngFor="let page of getPagesuser()">
                    <button class="page-btn" [disabled]="currentPage2 === page || !isValidPage(page)"
                        [class.active]="currentPage2 === page" (click)="isValidPage(page) && changePage2(page)">
                        {{ page }}
                    </button>
                </ng-container>
                <button class="page-btn" [disabled]="currentPage2 === totalPages2"
                    (click)="changePage2(currentPage2 + 1)">Next</button>
            </div>
        </nav>
    </div>
    <div class="action-buttons">
        <button class="download" (click)="downloadReport()">
            <i class="fa fa-download"></i> Download Report
        </button>

        <button class="upload" (click)="goBack()">
            <i class="fa fa-upload"></i> Upload Another File
        </button>

        <button class="back" (click)="goBackToHome()">
            <i class="fa fa-home"></i> Back to Dashboard
        </button>
    </div>
</div>

<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
    <p style="color: white">Loading...</p>
</ngx-spinner>